module.exports = __webpack_public_path__ + "static/media/2020.6.17妇女议事会.38542964.jpg";